import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FullPageLoader from "./FullPageLoader";

export default function PublicOnlyRoute({ children }) {
  const { user, token, loading } = useAuth();

  if (loading) {
    return <FullPageLoader show />;
  }

  if (token && user) {
    const role = user.role?.toLowerCase();

    if (role === "admin") return <Navigate to="/admin" replace />;
    if (role === "agent") return <Navigate to="/agent/dashboard" replace />;

    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
